import { Component, OnInit } from "@angular/core";
import { IRegistration } from "../../models/IRegistration";
import { IRegistrationConfirmation } from "../../models/IRegistrationConfirmation";
import { environment } from "../../../environments/environment";
import { RegistrationService } from "../../services/registration.service";
import { OrganizationBaseComponent } from "../OrganizationBaseComponent";
import { ActivatedRoute, Router } from "@angular/router";
import { IBreakoutGroup } from "../../models/IBreakoutGroup";

@Component({
    selector: "app-registration",
    templateUrl: "./registration.component.html",
    styleUrls: ["./registration.component.scss"]
})
export class RegistrationComponent extends OrganizationBaseComponent implements OnInit {
    public registration: IRegistration = {
        email: "",
        firstname: "",
        lastname: "",
        password: "",
        passwordConfirm: "",
        agbAccepted: false,
        language: environment.defaultLanguage,
        organizationKey: ""
    };

    public showRegistrationFormView: boolean = true;
    public showRegistrationSuccessfulView: boolean = false;
    public breakoutGroups: IBreakoutGroup[] = [];
    public selectedBreakoutGroupId: string;

    constructor(
        private registrationService: RegistrationService,
        protected route: ActivatedRoute,
        protected router: Router
    ) {
        super(router, route);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.push(
            this.route.queryParamMap.subscribe((params) => {
                const token = params.get("token");
                if (token) {
                    this.confirmRegistration(token);
                }
            })
        );

        this.registration.organizationKey = this.organizationKey;

        this.subscriptions.push(
            this.registrationService.breakoutgroups(this.organizationKey).subscribe((result) => {
                this.breakoutGroups = result.filter((group) => group.registrations < group.memberLimit);
            })
        );
    }

    register(): void {
        if (this.selectedBreakoutGroupId) {
            this.registration.misc = {
                breakoutGroupToRegister: this.selectedBreakoutGroupId
            };
        }

        this.subscriptions.push(
            this.registrationService.register(this.registration).subscribe((result: any) => {
                this.showRegistrationFormView = false;
                this.showRegistrationSuccessfulView = true;
            })
        );
    }

    confirmRegistration(token: string): void {
        const registrationConfirmation: IRegistrationConfirmation = {
            token: token,
            language: "en"
        };
        this.subscriptions.push(
            this.registrationService.confirmRegistration(registrationConfirmation).subscribe({
                next: (result) => {
                    this.router.navigate(["/login", this.organizationKey]);
                }
            })
        );
    }
}
